/* eslint-disable react/prop-types */

import React  from 'react';

const httpErrorStrings = {
    401: 'Authentication Failed',
    404: 'Resource not Found',
    500: 'Server Error',
};

function ErrorMessage({ error }) {
    if (error.response) {
        return <>
            <strong>{httpErrorStrings[error.response.status] || `Error type: ${error.response.status}`}</strong><br />
            {error.response?.data?.message || ''}<br />
        </>;
    }

    return <>
        {error?.message || error?.toString() || error}<br />
    </>;
}

export { ErrorMessage };
